import React, { Component } from 'react';
import { connect } from 'react-redux';
import Wrp from '../../hoc/Wrp/Wrp';
import ErrorDetails from './ErrorDetails';
import {
    setErrorListAction,
    clearErrorListAction,
    clearErrorElementsListAction,
    setErrorDetailListAction,
    showErrorDetailsAction
} from '../../store/actions/ErrorSetupAction';
import { withRouter } from 'react-router';
import * as actions from '../../store/actions';
import CallErrorElements from './CallErrorElements';
import {capitalizeFirstLetter, isSet}  from '../../Utils/CommonFunctions';
import { createPortal } from 'react-dom';


class ErrorComponent extends Component {
	constructor(props) {
        super(props);
        this.state ={
            isErrorModalOpen:false,  
			wrapperDom:null, 
            isErrorElementsModalOpen:false,   
            errorsList:[] ,
            showErrorDetails:false,
            errorObject:{
            	infoErrorList:[],	
            	errorErrorList:[],	
            	warningErrorList:[],
            	infoErrorListCount:0,
            	errorErrorListCount:0,
            	warningErrorListCount:0	
            }       
        }
    }

    componentDidMount = () => {
    	//console.log('componentDidMount')  
    	this.assignErrorHandler();  	
		const paginationTargetContainer = document.querySelector('body');
		console.log('paginationTargetContainer',paginationTargetContainer);
        this.setState({wrapperDom:paginationTargetContainer});
		
    }

	componentDidUpdate = (prevProps) => {
    	//console.log('componentDidUpdate')
    	if(prevProps.isErrorModalOpen!==this.props.isErrorModalOpen || prevProps.isErrorElementsModalOpen!==this.props.isErrorElementsModalOpen){
    		//console.log('componentDidUpdate inner')
    		this.assignErrorHandler();
			
    	} 
		// if(this.state.wrapperDom===null){
		// 	const paginationTargetContainer = document.querySelector('.wrapper');
		// 	console.log('paginationTargetContainer',paginationTargetContainer);
        // 	this.setState({wrapperDom:paginationTargetContainer});
		// }   	
    } 

    assignErrorHandler = () => {
    	const updateState = {...this.state};
    	let isOpen = this.props.isErrorModalOpen;
		let errorsList = this.props.errorsList;
		//console.log('componentDidUpdate',errorsList)
		let infoErrorList = [];
		let infoErrorListCount = 0;
		let errorErrorList = [];
		let errorErrorListCount = 0;
		let warningErrorList = [];
		let warningErrorListCount = 0;

		if(errorsList.length>0){
			errorsList.map((item,index)=>{
				if(item.type === 'error' || item.type === 'Error'){
					errorErrorList.push(item);
				}else if(item.type === 'info' || item.type === 'Info'){
					infoErrorList.push(item);
				}else if(item.type === 'warning' || item.type === 'Warning'){
					warningErrorList.push(item);
				}else{
					infoErrorList.push(item);
				}
			})
			infoErrorListCount = infoErrorList.length;
			warningErrorListCount = warningErrorList.length;
			errorErrorListCount = errorErrorList.length;

			updateState.errorObject['infoErrorList'] = infoErrorList;
			updateState.errorObject['errorErrorList'] = errorErrorList;
			updateState.errorObject['warningErrorList'] = warningErrorList;
			updateState.errorObject['infoErrorListCount'] = infoErrorList.length;
			updateState.errorObject['errorErrorListCount'] = errorErrorList.length;
			updateState.errorObject['warningErrorListCount'] = warningErrorList.length;				 
		}

		updateState.isErrorModalOpen = this.props.isErrorModalOpen;
		updateState.isErrorElementsModalOpen = this.props.isErrorElementsModalOpen;
		updateState.errorsList = this.props.errorsList;
		this.setState(updateState); 
		this.props.setErrorDetailListAction(updateState.errorObject)		  
		const timer = setTimeout(() => {
		    setTimeout(() => this.props.clearErrorElementsListAction());
	  	}, 5000);
    }

    clearErrorElements = () => {
    	this.setState({isErrorElementsModalOpen:false})
    }   


    showErrorDetailsHandler = () => {
    	//console.log('showErrorDetailsHandler',this.state.showErrorDetails)
    	this.setState({showErrorDetails:!this.state.showErrorDetails})
    }  

    
	render(){
		
		const {isErrorModalOpen,isErrorElementsModalOpen,showErrorDetails,errorsList,errorsDetailList} = this.props;
		const {infoErrorList,warningErrorList,errorErrorList} = errorsDetailList;
		//console.log('showErrorDetails==',showErrorDetails)
		return(
			<Wrp>

				{
					isErrorElementsModalOpen === true?<CallErrorElements {...this.state} />:<></>
				}

				



				{/*
					<div style={{display:(isOpen === true?'block':'none')}}>
						<div className="alert alert-primary p-0 rounded w-50 animated slideInDown" style={{"position":"fixed","top":"2rem","right":"0","left":"0","zIndex":"1052","margin": "0 auto"}}>
							<div className="card-header ">
							    <div className="card-title">
							      <h4 className="mb-0 text-bold"><i className="fas fa-exclamation-triangle  text-danger fa-lg"></i>
							      	Something stops you to proceed further.
							      	<a className="cursor-pointer" style={{"top":"0px","right":"10px","zIndex":"1","float":"right"}} onClick={e=>this.props.clearErrorListAction([])}><i className="fas fa-times fa-lg"></i></a>
							      </h4>
							    </div>
							</div>
							<div className="card-body d-flex align-items-center justify-content-between">
							    <div className="card card-transparent w-50 mr-2 mb-0">
							      <div className="card-body p-1">
							        <div>
							          <h5 className="text-medium text-info"> Info : <span className="badge badge-info ml-2">{infoErrorListCount}</span>
							          </h5>
							        </div>
							        <div className="progress progress-sm">
							          <div className="progress-bar progress-bar-striped active bg-info w-100" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
							        </div>
							      </div>
							    </div>						    
							    <div className="card card-transparent w-50 mr-2 mb-0">
							      <div className="card-body p-1">
							        <div>
							          <h5 className="text-medium text-warning"> Warning : <span className="badge badge-warning ml-2">{warningErrorListCount}</span>
							          </h5>
							        </div>
							        <div className="progress progress-sm">
							          <div className="progress-bar progress-bar-striped active bg-warning w-100" role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
							        </div>
							      </div>
							    </div>
							    <div className="card card-transparent w-50 mr-2 mb-0">
							      <div className="card-body p-1">
							        <div>
							          <h5 className="text-medium text-danger"> Error : <span className="badge badge-danger ml-2">{errorErrorListCount}</span>
							          </h5>
							        </div>
							        <div className="progress progress-sm">
							          <div className="progress-bar progress-bar-striped active bg-danger w-100" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
							        </div>
							      </div>
							    </div>
							</div>
							<div className="d-flex align-items-center justify-content-center">
							    <a className="mb-0 text-info textUnderline cursor-pointer quick-sidebar-toggler" onClick={this.showErrorDetailsHandler}>
							    	<i className="fas fa-hand-point-right fa-lg"> </i> Click to View Complete Alert Messages 
							    </a>
							</div>
						</div>
					</div>	
				*/}
				
				
										 
				{
					showErrorDetails === true?
					<>
					{isSet(this.state.wrapperDom,null)!==null && createPortal(
						<ErrorDetails 
							showErrorDetails={showErrorDetails}
							showErrorDetailsHandler={this.props.showErrorDetailsAction}
							errorsDetailList={errorsDetailList}					
							infoErrorList={infoErrorList}
							errorErrorList={errorErrorList}
							warningErrorList={warningErrorList}

					/>
					, this.state.wrapperDom)}
					</>
					
					:
					<></>
				}
				
				

			</Wrp>	
		)
	}
}

ErrorComponent.defaultProps = {
    
}

const mapDispatchToProps = dispatch => {
    return {      
      setErrorListAction:(arr)=>dispatch(setErrorListAction(arr)),
      clearErrorListAction:(arr)=>dispatch(clearErrorListAction(arr)),
      clearErrorElementsListAction:()=>dispatch(clearErrorElementsListAction()),
      setErrorDetailListAction:(obj)=>dispatch(setErrorDetailListAction(obj)),
      showErrorDetailsAction:()=>dispatch(showErrorDetailsAction()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg)),
      warningMessage : (msg) => dispatch(actions.warningMessage(msg)),
      infoMessage : (msg) => dispatch(actions.infoMessage(msg)),
    };
  }
const mapStateToProps = (state) => { 
	return {    
		isErrorModalOpen:state.ErrorSetupReducer.isErrorModalOpen,    
		isErrorElementsModalOpen:state.ErrorSetupReducer.isErrorElementsModalOpen,    
		showErrorDetails:state.ErrorSetupReducer.showErrorDetails,    
	    errorsList:state.ErrorSetupReducer.errorsList,
	    errorsDetailList:state.ErrorSetupReducer.errorsDetailList
	};
}

export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(ErrorComponent);

